import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import styles from './styles.scss';



const IntroductionSection: FC<{}> = (props) => {
	const { width } = useResizeObserver();
	const { transData } = useTranslation('tutors.introduction');
	return (
		<section className={styles['ac-introduction']} id='introduction'>
			<div className={styles['ac-introduction-container']}>
				<div className={styles['ac-introduction-content']}>
					<img className={styles['introduction-img-1']} loading='lazy' src={transData.img} alt="" />
					<img className={styles['introduction-img-2']} loading='lazy' src="https://web-data.zmlearn.com/image/f5xutp4oUabCEwJ7ZFa1mg/img_banner_arrow%402x.png" alt="" />
				</div>
				<img className={styles['introduction-img-3']} loading='lazy' src="https://web-data.zmlearn.com/image/rLcu465YCqzLngkFWNwhKZ/img_banner_2x.png" alt="" />
			</div>
		</section>
	);

}

export default IntroductionSection
